import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export const Footer = () =>{
    return(
    <>
    <div className="footerPage">
    <Container className="h-100">
        <Row className="h-100 align-items-center">
            <Col>
            <p className="mb-0 text-center text-muted">© 2023Monkey Royale Inc 2023</p>
            </Col>
        </Row>
    </Container>
    </div>
    </>
    )
}